export const LANGUAGES = [
  {
    code: "EN",
    value: "en",
    label: "English",
    flag: "https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/4.1.5/flags/4x3/gb.svg",
  },
  {
    code: "DE",
    value: "de",
    label: "Deutschland",
    flag: "https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/4.1.5/flags/4x3/de.svg",
  },
  {
    code: "VI",
    value: "vi",
    label: "Tiếng Việt",
    flag: "https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/4.1.5/flags/4x3/vn.svg",
  },
];
